import { Waypoint } from '../../../util/machine-variable.utils';
import { useRegisterAndSubscribeToMachineBindingSubscription } from '../../graphql/generated';

export interface CenterOfGravity {
  x: number;
  y: number;
  z: number;
}

export interface PayloadInertia {
  xx: number;
  xy: number;
  xz: number;
  yy: number;
  yz: number;
  zz: number;
}

export interface ToolConfigBindingContext {
  toolConfig: {
    name: string;
    tcp: Waypoint;
    mass: number;
    cog: CenterOfGravity;
    inertia: PayloadInertia;
  };
}

export interface ToolConfigBindingResult {
  success: boolean;
}

export const useSetToolConfigBinding = (
  machineId: string,
  context: ToolConfigBindingContext,
  options?: { skip?: boolean }
): ToolConfigBindingResult | undefined => {
  const { data } = useRegisterAndSubscribeToMachineBindingSubscription({
    skip: options?.skip,
    variables: {
      input: {
        machineId,
        binding: {
          namespace: 'machine',
          type: 'toolConfig',
          context,
        },
      },
    },
  });

  return data?.registerAndSubscribeToMachineBindingResult?.data;
};
